export default __webpack_public_path__ + "static/media/graphql2sparql.0408e664.png";